import { useEffect, useRef, useState } from 'react';

export default function BarcodeScanner({ onDetected, onClose }) {
  const videoRef = useRef(null);
  const [error, setError] = useState(null);
  const controlsRef = useRef(null);   // holds the controls object returned by decodeFromVideoDevice

  useEffect(() => {
    let active = true;

    async function start() {
      try {
        const { BrowserMultiFormatReader } = await import('@zxing/browser');
        const reader = new BrowserMultiFormatReader();
        const devices = await BrowserMultiFormatReader.listVideoInputDevices();
        const deviceId =
          devices.find(d => /back|rear|environment/i.test(d.label))?.deviceId ||
          devices[0]?.deviceId;

        if (!deviceId) {
          setError('No camera found');
          return;
        }

        // decodeFromVideoDevice returns a controls object with a .stop() method
        const controls = await reader.decodeFromVideoDevice(
          deviceId,
          videoRef.current,
          (result) => {
            if (!active) return;
            if (result) {
              onDetected(result.getText());
            }
          }
        );

        if (active) {
          controlsRef.current = controls;
        } else {
          // component unmounted before decode started — stop immediately
          try { controls.stop(); } catch (_) {}
        }
      } catch (e) {
        if (active) setError(e.message || 'Camera access denied');
      }
    }

    start();

    return () => {
      active = false;
      if (controlsRef.current) {
        try { controlsRef.current.stop(); } catch (_) {}
        controlsRef.current = null;
      }
    };
  }, [onDetected]);

  return (
    <div style={{
      position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.85)',
      display: 'flex', flexDirection: 'column', alignItems: 'center',
      justifyContent: 'center', zIndex: 1000,
    }}>
      <div style={{ position: 'relative', width: '100%', maxWidth: 400 }}>
        {error ? (
          <div className="alert alert-danger" style={{ margin: 16 }}>{error}</div>
        ) : (
          <video
            ref={videoRef}
            style={{ width: '100%', borderRadius: 12 }}
            autoPlay
            playsInline
            muted
          />
        )}
        <div style={{
          position: 'absolute', top: '50%', left: '10%', right: '10%',
          height: 2, background: '#6C63FF', transform: 'translateY(-50%)',
          boxShadow: '0 0 8px #6C63FF',
        }} />
      </div>
      <p style={{ color: '#fff', marginTop: 16, fontSize: '0.9rem' }}>
        Point camera at barcode
      </p>
      <button className="btn btn-secondary" onClick={onClose} style={{ marginTop: 12 }}>
        Cancel
      </button>
    </div>
  );
}
